<template>
    <span
        :class="{
            container: true,
            absolute: absolutelyPositioned,
            'one-coin': iconsTokenAddresses.length === 1,
            'two-coins': iconsTokenAddresses.length === 2,
            'three-coins': iconsTokenAddresses.length === 3,
            'four-coins': iconsTokenAddresses.length === 4,
            'five-coins': iconsTokenAddresses.length === 5,
        }"
    >
        <span v-for="tokenAddress in iconsTokenAddresses" class="crypto-icon-fallback" />
        <span
            v-for="tokenAddress in iconsTokenAddresses"
            class="crypto-icon"
            :style="{'background-image': `url(${getTokenIcon(tokenAddress)})` }"
        />
    </span>
</template>

<script>
    import { getTokenIcon } from '@/utils/helpers';
    import config from '@/constants/config'
    import coins from '@/constants/coins'
    import { formatLargeNumber } from '../../utils/Number';

	export default {
        data: () => ({
            config,
        }),
        computed: {
            iconsTokenAddresses() {
                const displayedCoins = this.pool.isMetaPool ? [this.pool.coins[0]] : this.pool.coins;
                const overridenCoins = (
                    (this.pool.cryptoPool && this.pool.isFactoryOnlyPool) ? (
                        displayedCoins.map((coin) => (
                            coin.address.toLowerCase() === coins[config.nativeAssetErc20WrapperId].address.toLowerCase() ?
                                coins[config.nativeAssetId] :
                                coin
                        ))
                    ) :
                    displayedCoins
                );
                return overridenCoins.map(({ address }) => address.toLowerCase());
            }
        },
        methods: {
            getTokenIcon,
        },
        props: {
            pool: {
                type: Object,
            },
            absolutelyPositioned: {
                type: Boolean,
                default: false,
            },
        },
	}
</script>

<style scoped>
    .crypto-icon {
        display: inline-block;
        background-size: 100% auto;
        border-radius: 50%;
    }

    .absolute .crypto-icon,
    .absolute .crypto-icon-fallback {
        position: absolute;
        top: 9px;
        left: 0;
    }

    .absolute .crypto-icon-fallback {
        border-radius: 50%;
        background: grey;
    }

    .absolute.container.one-coin .crypto-icon-fallback,
    .absolute.container.one-coin .crypto-icon {
        width: 24px;
        height: 24px;
    }

    .absolute.container.two-coins .crypto-icon-fallback,
    .absolute.container.two-coins .crypto-icon {
        width: 18px;
        height: 18px;
    }

    .absolute.container.two-coins .crypto-icon-fallback:nth-child(2),
    .absolute.container.two-coins .crypto-icon:nth-child(4) {
        z-index: 1;
        top: 15px;
        left: 6px;
    }

    .absolute.container.three-coins .crypto-icon-fallback,
    .absolute.container.three-coins .crypto-icon {
        width: 18px;
        height: 18px;
    }

    .absolute.container.three-coins .crypto-icon-fallback:nth-child(2),
    .absolute.container.three-coins .crypto-icon:nth-child(5) {
        z-index: 1;
        left: 6px;
    }

    .absolute.container.three-coins .crypto-icon-fallback:nth-child(3),
    .absolute.container.three-coins .crypto-icon:nth-child(6) {
        z-index: 2;
        top: 15px;
        left: 3px;
    }

    .absolute.container.four-coins .crypto-icon-fallback,
    .absolute.container.four-coins .crypto-icon {
        width: 16px;
        height: 16px;
    }

    .absolute.container.four-coins .crypto-icon-fallback:nth-child(2),
    .absolute.container.four-coins .crypto-icon:nth-child(6) {
        z-index: 1;
        left: 8px;
    }

    .absolute.container.four-coins .crypto-icon-fallback:nth-child(3),
    .absolute.container.four-coins .crypto-icon:nth-child(7) {
        z-index: 2;
        top: 17px;
        left: 0px;
    }

    .absolute.container.four-coins .crypto-icon-fallback:nth-child(4),
    .absolute.container.four-coins .crypto-icon:nth-child(8) {
        z-index: 3;
        top: 17px;
        left: 8px;
    }

    .absolute.container.five-coins .crypto-icon-fallback,
    .absolute.container.five-coins .crypto-icon {
        width: 12px;
        height: 12px;
    }

    .absolute.container.five-coins .crypto-icon-fallback:nth-child(1),
    .absolute.container.five-coins .crypto-icon:nth-child(6) {
        left: 2px;
    }

    .absolute.container.five-coins .crypto-icon-fallback:nth-child(2),
    .absolute.container.five-coins .crypto-icon:nth-child(7) {
        z-index: 4;
        left: 10px;
    }

    .absolute.container.five-coins .crypto-icon-fallback:nth-child(3),
    .absolute.container.five-coins .crypto-icon:nth-child(8) {
        z-index: 1;
        top: 15px;
        left: 0px;
    }

    .absolute.container.five-coins .crypto-icon-fallback:nth-child(4),
    .absolute.container.five-coins .crypto-icon:nth-child(9) {
        z-index: 2;
        top: 21px;
        left: 6px;
    }

    .absolute.container.five-coins .crypto-icon-fallback:nth-child(5),
    .absolute.container.five-coins .crypto-icon:nth-child(10) {
        z-index: 3;
        top: 15px;
        left: 12px;
    }
</style>
